export const HERO_IMAGE =
    "https://static.wixstatic.com/media/43af132084674132912fa5edc4902eb4.jpg/v1/fill/w_1611,h_840,al_c,q_85,enc_avif,quality_auto/43af132084674132912fa5edc4902eb4.jpg";

export const WHY_IMAGE =
    "https://static.wixstatic.com/media/c66a35_ee989dd373b84a15abaeeae75ab502b0~mv2.png/v1/crop/x_0,y_305,w_1080,h_758/fill/w_586,h_412,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Dise%C3%B1o%20sin%20t%C3%ADtulo-41.png";

export const CATALOG_URL =
    "https://static.wixstatic.com/ugd/c66a35_3eb6f83364f94faba359dc525cc3738f.pdf";

export const B2B_URL = "https://www.tugekocr.com/nuevosclientes";

export const BLOG_POSTS = [
    {
        title: "¿Cómo escoger el alimento ideal para mis aves?",
        excerpt:
            "Elegir un alimento de calidad para tu ave puede ser la diferencia entre verlos brillar y cantar o no.",
        image: "https://static.wixstatic.com/media/c66a35_7974740ead9f438ea5ffc0a221879b1a~mv2.png/v1/fill/w_292,h_219,fp_0.50_0.50,q_95,enc_avif,quality_auto/c66a35_7974740ead9f438ea5ffc0a221879b1a~mv2.webp",
        url: "https://www.lolopetscr.com/post/c%C3%B3mo-escoger-el-alimento-ideal-para-mis-aves",
    },
    {
        title: "¿Por qué la alimentación equilibrada es clave para la salud de tus pequeños roedores?",
        excerpt:
            "Un hámster saludable demuestra su bienestar en sus niveles de energía y en los colores de su pelaje.",
        image: "https://static.wixstatic.com/media/c66a35_07aadadf81b04c42bdc7cc81b0659eb0~mv2.png/v1/fill/w_292,h_219,fp_0.50_0.50,q_95,enc_avif,quality_auto/c66a35_07aadadf81b04c42bdc7cc81b0659eb0~mv2.webp",
        url: "https://www.lolopetscr.com/post/por-qu%C3%A9-la-alimentaci%C3%B3n-equilibrada-es-clave-para-la-salud-de-tus-peque%C3%B1os-roedores",
    },
    {
        title: "Enriquecimiento ambiental para hámsters y conejos",
        excerpt:
            "¿Tu hámster corre siempre en su rueda? ¿Tu conejo mastica todo lo que encuentra? Esto es para vos.",
        image: "https://static.wixstatic.com/media/c66a35_0c88168fc2694557b82abaaa99912952~mv2.png/v1/fill/w_292,h_219,fp_0.50_0.50,q_95,enc_avif,quality_auto/c66a35_0c88168fc2694557b82abaaa99912952~mv2.webp",
        url: "https://www.lolopetscr.com/post/haz-feliz-a-tu-peludito-enriquecimiento-ambiental-para-h%C3%A1msters-y-conejos",
    },
];

export const FAQ_ITEMS = [
    {
        q: "¿Dónde puedo comprar productos LoloPets?",
        a: "LoloPets está disponible en las principales veterinarias y pet shops de Costa Rica. Escríbenos por WhatsApp y con gusto te indicamos el punto de venta más cercano.",
    },
    {
        q: "¿LoloPets vende directamente al cliente final?",
        a: "No. LoloPets es distribuido por Tugeko S.A. y llega a vos únicamente a través de veterinarias y pet shops del país, donde recibís asesoría especializada.",
    },
    {
        q: "¿Qué alimento le conviene a mi ave?",
        a: "La línea Foody Premium ofrece alimento completo formulado por especie: canarios, periquitos y cocateles (ninfas). Como complemento, las barritas Smakers aportan variedad, enriquecimiento y un premio saludable.",
    },
    {
        q: "¿Qué necesita mi conejo o roedor además de alimento?",
        a: "Además de un alimento completo como Foody Premium, el heno es esencial para la digestión y el desgaste dental. Los túneles con heno, el zacate y los bloques minerales aportan enriquecimiento ambiental y bienestar.",
    },
    {
        q: "¿Qué significa que LoloPets sea un producto europeo?",
        a: "Significa formulación de calidad europea: cada ingrediente tiene una función y un propósito pensado para mejorar la salud y el bienestar de tu mascota. Es la calidad que nuestras mascotas se merecen.",
    },
    {
        q: "Tengo una veterinaria o pet shop, ¿cómo puedo vender LoloPets?",
        a: "Completa el formulario de nuevos clientes de Tugeko S.A. o escríbenos por WhatsApp. Te contactaremos para incorporar LoloPets a tu negocio con respaldo de marca y catálogo completo.",
        link: { label: "Ir al formulario de nuevos clientes de Tugeko", url: "https://www.tugekocr.com/nuevosclientes" },
    },
];

export const NAV_LINKS = [
    { label: "Inicio", href: "#inicio" },
    { label: "Productos", href: "#productos" },
    { label: "¿Por qué LoloPets?", href: "#por-que" },
    { label: "Distribuidores", href: "#distribuidores" },
    { label: "Consejos", href: "#consejos" },
    { label: "Preguntas", href: "#preguntas" },
];

export function buildWhatsAppUrl(number, message) {
    if (!number) return "/#contacto";
    const text = encodeURIComponent(message || "Hola LoloPets, quiero más información sobre sus productos.");
    return `https://wa.me/${number}?text=${text}`;
}
